import { cn } from "@/lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface ScrollArrowsProps {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
}

export function ScrollArrows({ canScrollLeft, canScrollRight, onScrollLeft, onScrollRight }: ScrollArrowsProps) {
  if (!canScrollLeft && !canScrollRight) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none sticky bottom-8 left-0 right-0 z-20 flex h-0 items-center justify-between px-2"
    >
      <button
        type="button"
        onClick={onScrollLeft}
        aria-label="Scroll table left"
        tabIndex={canScrollLeft ? 0 : -1}
        className={cn(
          "pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-xl transition hover:bg-secondary hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          !canScrollLeft && "invisible",
        )}
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={onScrollRight}
        aria-label="Scroll table right"
        tabIndex={canScrollRight ? 0 : -1}
        className={cn(
          "pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-xl transition hover:bg-secondary hover:shadow-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          !canScrollRight && "invisible",
        )}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
